import React, { useState } from 'react';
import ExcomDashboard from './ExcomDashboard';
import ExcomMeetings from './ExcomMeetings';
import { PageHeader, Tabs } from '../../components/ui';

const TABS = [
    { value: 'dashboard', label: 'Dashboard' },
    { value: 'meetings', label: 'Meetings' },
];

const Excom = () => {
    const [activeTab, setActiveTab] = useState('dashboard');

    return (
        <>
            <PageHeader
                title="Executive Committee"
                description="Oversight of Excom meetings, decisions and follow-up actions."
                breadcrumbs={[{ label: 'Home', to: '/' }, { label: 'Excom' }]}
            />

            <Tabs tabs={TABS} value={activeTab} onChange={setActiveTab} className="mb-4" />

            {activeTab === 'meetings' ? <ExcomMeetings /> : <ExcomDashboard />}
        </>
    );
};

export default Excom;
